import ApiForm from '@/Shared/Component/Forms/ApiForm.vue'
import BaseMeetingCard from '@/App/Booking/Meeting/Component/BaseMeetingCard.vue'
import MeetingData from '@/App/Booking/Meeting/Entity/MeetingData'
import type { MeetingLocationTypeEnum } from '@/Shared/AutoGenerated/Main'

/**
 * BaseApp
 */

export type ApiFormRefType = InstanceType<typeof ApiForm> | null
export type BaseMeetingCardRefType = InstanceType<typeof BaseMeetingCard> | null

/**
 * App
 */

export interface MeetingsDataGroupedByDate {
    rawDate: string
    formattedDate: string
    dayOfWeek: string
    meetingsData: MeetingData[]
}

export interface EmbedButtonDestinationUrl {
    title: string
    url: string
    isDisabled: boolean
}

export const IN_PERSON_MEETING_LOCATIONS_SECTION_ID =
    'IN_PERSON_MEETING_LOCATIONS_SECTION'

export enum MeetingTabKeyEnum {
    Meeting = 'meeting',
    Recurring = 'recurring',
}

export interface MeetingsLocationDataInterface {
    type: MeetingLocationTypeEnum
    label: string
    description: string
    url: string | null
}

export interface ConfirmBookMeetingOnStartCallbackParams {
    //
}

export interface ConfirmBookMeetingOnErrorCallbackParams {
    message: string | null
}

export interface ConfirmBookMeetingOnScheduleMeetingRequested {
    //
}

export type ConfirmBookMeetingCanScheduleMeetingCallback = () => boolean
